export default {
    version: '1.1.34',
}
